import React, {FunctionComponent} from "react";
import StickyBox from "react-sticky-box";
import Layout from "./Layout";

type Props = {
    content: any;
    location: string[];
    toc?: any;
    frontmatter?: any;
    delocalizedSlug: string;
};

const LayoutWithoutMenu: FunctionComponent<Props> = ({content, frontmatter, toc, location, delocalizedSlug}) => {
    return (
        <Layout location={location} frontmatter={frontmatter} hideContentNavigationInHeader={true} navigationMarkdownEdges={[]} delocalizedSlug={delocalizedSlug}>
            <div className="content-navigation only-desktop">
            </div>
            <div className="content">
                {content}
            </div>
            <div className="page-toc">
                <StickyBox offsetTop={20} offsetBottom={20}>
                    {toc}
                </StickyBox>
            </div>
        </Layout>
    );
}

export default LayoutWithoutMenu;
